import axios from 'axios'
import { ServiceError } from '@bt-react/constants'
import { SurveyProps } from '@bt-react/store'
import { surveyTypes } from './surveyTypes'
import get from 'lodash/get'
import has from 'lodash/has'

/* get survey */
export const getSurvey = () => async (dispatch, getState): Promise<void> => {

    dispatch({ type: surveyTypes.FETCH_SURVEY })

    try {

        const state = getState()

        const response = await axios.get(state.survey.api)

        const res = {
          items: [],
          id: response.data.id,
          isActive: response.data.isActive
        }
        res.items = response.data.items.map(parseItem)
        dispatch({ type: surveyTypes.FETCH_SURVEY_SUCCESS, payload: res })

    }
    catch (e) {

      const errorCode = ['SurveyNotFound', 'ResourceNotFound']

      if (e && e.response && e.response.status === 404 && errorCode.includes(e.response.data.code)) {

        dispatch({ type: surveyTypes.HANDLE_SURVEY_NOT_FOUND_RESPONSE, payload: e.data })

      } else {

        const status = get(e, 'request.status', 500)
        let errorMessage = {}
    
        switch (status) {
    
          case 500:
            errorMessage = {
              code: 500,
              message: ServiceError.NETWORK_ERROR
            }
            break
          default:
            errorMessage = {
              code: e.request.status,
              message: e.message
            }
    
        }
    
        dispatch({ type: surveyTypes.FETCH_SURVEY_FAILED, payload: {error: errorMessage}})
      }

    }

}

const parseItem = item => {

  item.dropId = item.id

  switch (item.type) {

    case 'text':

      item.type = getType(item)
      break
    case 'select':
    case 'multiSelect':

      item.options = convertOptionsUnMarshal(item.options)
      break

  }

  item.text = getText(item)
  item.icon = getIcon(item)
  item.summary = getSummary(item)
  item = getRequired(item)

  return item

}

const getIcon = item => {

  switch (item.type) {

    case 'heading':
      return 'heading'
    case 'staticText':
      return 'textHeight'
    case 'textbox':
      return 'textWidth'
    case 'commentBox':
      return 'comment'
    case 'select':
      return 'dotCircle'
    case 'multiSelect':
      return 'list'
    case 'checkbox':
      return 'check'

  }

}

const getType = item => {

  if (item.label) {

    if (item.scroll) {

      return 'commentBox'

    }

    return 'textbox'

  }
  else if (item.readOnly) {

    return 'staticText'

  }

}

const getRequired = item => {

  switch (item.type) {

    case 'heading':
    case 'staticText':

      return item
    case 'checkbox':
    case 'select':
    case 'multiSelect':
    case 'commentBox':
    case 'textbox':

      if (item.required === undefined) {

        item.required = false

      }
      return item
    default:
      return item

  }

}

const getSummary = item => {

  switch (item.type) {

    case 'heading':
    case 'staticText':

      return item.content

    case 'checkbox':
    case 'select':
    case 'multiSelect':
    case 'commentBox':
    case 'textbox':

      return item.label

  }

}

// This logic could be moved into the newItemForm and the text property could be removed
const getText = item => {

  switch (item.type) {

    case 'heading':

      return 'Header'

    case 'staticText':

      return 'Static Text'

    case 'commentBox':

      return 'Comment Box'

    case 'textbox':

      return 'Text Box'

    case 'checkbox':

      return 'Tick Box'

    case 'select':

      return 'Single Select'

    case 'multiSelect':

      return 'Multiple Choice'

  }

}

export const convertOptionsMarshal = options => {

  return options.map(option => {

    return {
      'value': option,
      'label': option
    }

  })
  
}

export const convertOptionsUnMarshal = options => {

  return options.map(option => {

    return option.label

  })

}

export const marshalSurvey = (state, type = '') => async (dispatch) => {

    const survey: SurveyProps = {
        items: [],
        id: state.survey.data.id,
        isActive: state.survey.data.isActive
    }

    const hasItems = has(state.survey, 'data.items') && state.survey.data.items.filter(item => !item.deleted)

    if (hasItems && hasItems.length === 0) {
      survey.isActive = false
    } else if (hasItems && hasItems.length === 1 && (state.survey.modal || type === 'unDeleteItem')) {
      survey.isActive = true
    }
  
    survey.items = state.survey.data.items.map(item => {
  
      // item.id = item.id || item.dropId // new items are being sent with a random ID - this should be left blank so the API auto assigns. However, the mockapi would need a custom route that inspected the payload and add an ID for it to replicate what the real API was doing.
      // item.label = item.text - stopped because label should not be auto set to "Text box"
      delete item.dropId
      delete item.text
      delete item.summary
      delete item.icon
      delete item.fromIndex // should move this somewhere else - this incorrectly remains part of the state
  
      switch (item.type) {
  
        case 'staticText':
        case 'commentBox':
        case 'textbox':
  
          item.type = 'text'
          break
        case 'select':
        case 'multiSelect':
  
          item.options = convertOptionsMarshal(item.options)
          break
        default:
          break
  
      }
  
      // todo make local sb use label property
      return item
  
    })
    return survey
  
  }

/* Put survey */
export const putSurvey = (type = '') => async (dispatch, getState) => {

  const state = getState()
  const survey = await dispatch(marshalSurvey(state, type))

  const response = await axios.put(state.survey.api, survey)

  const res = {
    items: [],
    id: response.data.id,
    isActive: response.data.isActive
  }
  res.items = response.data.items.map(parseItem)
  dispatch({ type: surveyTypes.UNMARSHAL_SURVEY_RESPONSE, payload: res })

}

/* Post survey */
export const postSurvey = () => async (dispatch, getState) => {

  const state = getState()
  const survey = await dispatch(marshalSurvey(state))

  const response = await axios.post(state.survey.api, survey)

  const res = {
    items: [],
    id: response.data.id,
    isActive: response.data.isActive
  }
  res.items = response.data.items.map(parseItem)

  dispatch({ type: surveyTypes.UNMARSHAL_SURVEY_RESPONSE, payload: res })

}

export const openModal = item => async (dispatch) => {

  dispatch({ type:surveyTypes.OPEN_MODAL, payload: item })

}

export const closeModals = () => async (dispatch) => {

  dispatch({ type:surveyTypes.CLOSE_MODALS })

}

export const openConfirmModal = item => async (dispatch) => {

  dispatch({ type: surveyTypes.OPEN_CONFIRM_MODAL, payload: item })

}

export const closeConfirmModal = () => async (dispatch) => {

  dispatch({ type: surveyTypes.CLOSE_CONFIRM_MODAL })

}

export const deactivateSurvey = () => async (dispatch) => {

  dispatch({ type: surveyTypes.DEACTIVATE_SURVEY })

}

export const activateSurvey = () => async (dispatch) => {

  dispatch({ type: surveyTypes.ACTIVATE_SURVEY })

}

export const saveNewSurveyItem = item => async (dispatch) => {

  dispatch({ type: surveyTypes.SAVE_NEW_SURVEY_ITEM, payload: item })

}

export const insertItem = (id, atIndex, item) => async (dispatch) => {

  dispatch({ type: surveyTypes.INSERT_ITEM, payload: { id, atIndex, item } })

}

export const moveItem = (item) => async (dispatch) => {

  dispatch({ type: surveyTypes.MOVE_ITEM, payload: item })

}

export const deleteItem = fromIndex => async (dispatch) => {

  dispatch({ type: surveyTypes.DELETE_ITEM, payload: fromIndex })

}

export const unDeleteItem = reportName => async (dispatch) => {

  dispatch({ type: surveyTypes.UNDELETE_ITEM, payload: reportName })

}

export const confirmDelete = (fromIndex, item) => async (dispatch) => {

  dispatch({ type: surveyTypes.CONFIRM_DELETE, payload: item })

}

export const deleteNonDropped = () => async (dispatch) => {

  dispatch({ type: surveyTypes.DELETE_NON_DROPPED })

}

export const openEditModal = item => async (dispatch) => {

  dispatch({ type: surveyTypes.OPEN_EDIT_MODAL, payload: item })

}

export const openDuplicateModal = item => async (dispatch) => {

  dispatch({ type: surveyTypes.OPEN_DUPLICATE_MODAL, payload: item })

}

export const setSurveyApi = (url) => async (dispatch) => {

  dispatch({ type: surveyTypes.SET_SURVEY_API, payload: url })

}
